const InstagramShowcase = () => {
  return (
    <section className="instagram_img_area">
      <div className="container">
        <h3 className="block_heading">
          <div className="block_heading_dash">+</div>
          <span>Follow us on Instagram</span>
          <div className="block_heading_dash">+</div>
        </h3>
      </div>
      <div className="instagram_img_container">
        <div className="insta_row d-flex">
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="insta_img_box"
          >
            <img
              src={require('assets/images/insta1.jpg').default}
              className="img-responsive"
              alt="category"
            />
          </a>
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="insta_img_box"
          >
            <img
              src={require('assets/images/insta2.jpg').default}
              className="img-responsive"
              alt="category"
            />
          </a>
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="insta_img_box"
          >
            <img
              src={require('assets/images/insta3.jpg').default}
              className="img-responsive"
              alt="category"
            />
          </a>
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="insta_img_box"
          >
            <img
              src={require('assets/images/insta4.jpg').default}
              className="img-responsive"
              alt="category"
            />
          </a>
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            className="insta_img_box"
          >
            <img
              src={require('assets/images/insta5.jpg').default}
              className="img-responsive"
              alt="category"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramShowcase;
